// extracted by mini-css-extract-plugin
module.exports = {"language":"LanguageSwitcher_language__2bjyy"};